import { ProductPricing } from 'enums/product';
import { CollectionStampCardImageTextType } from 'enums/stampCard';
import { CollectionStampCard } from 'types/next';

// Initialize retailer side collection stamp card data
export const initializeCollectionStampCard = (item: CollectionStampCard) => {
  // Initialize product based reward data
  if (item.reward.type === 'productEur') {
    if (item.rewardProducts?.length) {
      const hasPerPiecePricedProducts = item.rewardProducts?.some(
        (product) => product.pricingUnit === ProductPricing.PerPiece,
      );
      const hasPerWeightPricedProducts = item.rewardProducts?.some(
        (product) => product.pricingUnit === ProductPricing.Weight,
      );
      // Has only weight priced products
      if (hasPerWeightPricedProducts && !hasPerPiecePricedProducts) {
        item.reward.pricingUnit = ProductPricing.Weight;
        if (!item.reward.itemLimit) {
          item.reward.itemLimit = 100; // reset to 100g
        }
      }
      // Has only per piece priced products
      if (hasPerPiecePricedProducts && !hasPerWeightPricedProducts) {
        item.reward.pricingUnit = ProductPricing.PerPiece;
        item.reward.itemLimit = 1; // item limit is always 1
      }
    }
  }

  return item;
};

export const getCollectionStampCardImageHTML = ({
  preview,
  textType,
  backgroundUrl,
  text,
  textBackgroundColor,
  textForegroundColor,
  replaced,
  file,
}: {
  preview: boolean;
  textType: CollectionStampCardImageTextType;
  backgroundUrl: string;
  text: string;
  textBackgroundColor: string;
  textForegroundColor: string;
  replaced?: boolean;
  file?: string | ArrayBuffer;
}) => {
  let cardWidth = 1000;
  let cardHeight = 540;
  let textWrapperWidth = 872;
  let textWrapperHeight = 64;
  let textWrapperPositionBottom = 64;
  let textWrapperPositionLeft = 900;
  let textMaxWidth = 872;
  let textMaxHeight = 41;
  let textSize = 38;
  let topBottomPadding = 11.5;
  let rightLeftPadding = 14.58;
  let gap = 11.66;
  let textWrapperBorderRadius = 23.9448;
  let textWrapperLineHeight = 41;

  if (preview) {
    cardWidth = Math.ceil(cardWidth / 2.5);
    cardHeight = Math.ceil(cardHeight / 2.5);
    textWrapperHeight = Math.ceil(textWrapperHeight / 2.5);
    textMaxWidth = Math.ceil(textMaxWidth / 2.5);
    textSize = Math.ceil(textSize / 2.5);
    textWrapperPositionBottom = Math.ceil(textWrapperPositionBottom / 2.5);
    topBottomPadding = Math.ceil(topBottomPadding / 2.5);
    rightLeftPadding = Math.ceil(rightLeftPadding / 2.5);
    gap = Math.ceil(gap / 2.5);
    textWrapperWidth = Math.ceil(textWrapperWidth / 2.5);
    textWrapperBorderRadius = Math.ceil(textWrapperBorderRadius / 2.5);
    textWrapperLineHeight = Math.ceil(textWrapperLineHeight / 2.5);
    textMaxHeight = Math.ceil(textMaxHeight / 2.5);
    textWrapperPositionLeft = 360;
  }

  const textDisplay = textType === CollectionStampCardImageTextType.None ? 'none' : 'flex';

  const html = `
  <!doctype html>
  <html lang="en">
  <head>
    <meta charset="utf-8">
    <style>
        body { margin: 0; }
        @font-face {
          font-family: 'SkattaSans-CondensedBlack';
          src: url('https://campaign.kesko.fi/res/kesko/SkattaSans-Condensed-Black.ttf') format('truetype');
          font-weight: 900;
          font-stretch: condensed;
        }
        .stampcard-image-editor-preview--card {
        width: ${cardWidth}px;
        height: ${cardHeight}px;
        background-image: url('${file ? file : replaced ? backgroundUrl + '?' + Date.now() : backgroundUrl}');
        position: relative;
        background-size: contain;
      }
       .stampcard-image-editor-preview--text {
        left: calc(50% - ${textWrapperPositionLeft}px / 2);
        bottom: ${textWrapperPositionBottom}px;
        width: ${textWrapperWidth}px;
        height: ${textWrapperHeight}px;
        display: ${textDisplay};
        position: absolute;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: ${topBottomPadding}px ${rightLeftPadding}px;
        font-family: "SkattaSans-CondensedBlack", sans-serif;
        background-color: ${textBackgroundColor};
        border-radius: ${textWrapperBorderRadius}px;
        gap: ${gap}px;
      }
      
      .stampcard-image-editor-preview--text .text {
        font-size: ${textSize}px;
        max-width: ${textMaxWidth}px;
        text-align: center;
        color: ${textForegroundColor};
        z-index: 1;
        text-transform: uppercase;
        line-height: ${textWrapperLineHeight}px;
        width: ${textMaxWidth}px;
        height: ${textMaxHeight}px;
        flex: none;
        order: 0;
        flex-grow: 0;
      }
       
    </style>
  </head>
  <body>
    <div class="stampcard-image-editor-preview--card">
        <div class="stampcard-image-editor-preview--text">
            <div class="text">${text}</div>
        </div>
    </div>
  </body>
  </html>
  `;

  return html;
};
